export type PreventAutofocusProp = {preventAutofocus?: boolean}

export interface NavigateOptionExtensions extends PreventAutofocusProp {
  reloadDocument?: boolean
  preventTurbo?: boolean
}

export const PREVENT_AUTOFOCUS_KEY = '__gh__react-core-preventAutofocus'
